import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { initMetaPixel } from "./lib/metaPixel";
import "./index.css";

// Loads only when a Meta Pixel ID is configured in src/config/ads.ts
initMetaPixel();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
